var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 18,
    viewBox: "0 0 30 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75",
    transform: "translate(-5677.983 772.559)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_102",
    "data-name": "Rectangle 102",
    width: 30,
    height: 1.385,
    transform: "translate(5677.983 -755.944)",
    fill: "#cb001c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_103",
    "data-name": "Rectangle 103",
    width: 30,
    height: 1.385,
    transform: "translate(5677.983 -757.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_104",
    "data-name": "Rectangle 104",
    width: 30,
    height: 1.384,
    transform: "translate(5677.983 -758.712)",
    fill: "#cb001c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_105",
    "data-name": "Rectangle 105",
    width: 30,
    height: 1.385,
    transform: "translate(5677.983 -760.097)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_106",
    "data-name": "Rectangle 106",
    width: 30,
    height: 1.385,
    transform: "translate(5677.983 -761.482)",
    fill: "#cb001c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_107",
    "data-name": "Rectangle 107",
    width: 30,
    height: 1.384,
    transform: "translate(5677.983 -762.865)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_108",
    "data-name": "Rectangle 108",
    width: 30,
    height: 1.386,
    transform: "translate(5677.983 -764.252)",
    fill: "#cb001c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_109",
    "data-name": "Rectangle 109",
    width: 30,
    height: 1.384,
    transform: "translate(5677.983 -765.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_110",
    "data-name": "Rectangle 110",
    width: 30,
    height: 1.385,
    transform: "translate(5677.983 -767.02)",
    fill: "#cb001c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111",
    "data-name": "Rectangle 111",
    width: 30,
    height: 1.385,
    transform: "translate(5677.983 -768.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112",
    "data-name": "Rectangle 112",
    width: 30,
    height: 1.385,
    transform: "translate(5677.983 -769.789)",
    fill: "#cb001c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_113",
    "data-name": "Rectangle 113",
    width: 30,
    height: 1.385,
    transform: "translate(5677.983 -771.174)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114",
    "data-name": "Rectangle 114",
    width: 30,
    height: 1.385,
    transform: "translate(5677.983 -772.559)",
    fill: "#cb001c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_115",
    "data-name": "Rectangle 115",
    width: 13.7,
    height: 9.694,
    transform: "translate(5677.983 -772.559)",
    fill: "#2a3560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M418.31,1.162l.117.367h.375l-.3.227.115.366-.3-.226-.3.226.119-.366-.3-.227h.372Z",
    transform: "translate(5260.911 -772.653)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M418.31,2.923l.117.365h.375l-.3.226.115.368-.3-.227-.3.227.119-.368-.3-.226h.372Z",
    transform: "translate(5260.911 -772.795)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M418.31,4.683l.117.366h.375l-.3.226.115.367-.3-.227-.3.227.119-.367-.3-.226h.372Z",
    transform: "translate(5260.911 -772.937)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M418.31,6.442l.117.367h.375l-.3.226.115.366-.3-.225-.3.225.119-.366-.3-.226h.372Z",
    transform: "translate(5260.911 -773.078)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M418.31,8.2l.117.368h.375l-.3.225.115.366-.3-.226-.3.226.119-.366-.3-.225h.372Z",
    transform: "translate(5260.911 -773.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M419.536,2.089l.112.367h.377l-.3.227.114.366-.3-.225-.3.225.113-.366-.3-.227h.375Z",
    transform: "translate(5260.781 -772.727)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M419.536,3.85l.112.366h.377l-.3.227.114.365-.3-.224-.3.224.113-.365-.3-.227h.375Z",
    transform: "translate(5260.781 -772.869)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M419.536,5.61l.112.366h.377l-.3.227.114.366-.3-.226-.3.226.113-.366-.3-.227h.375Z",
    transform: "translate(5260.781 -773.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M419.536,7.37l.112.366h.377l-.3.226.114.365-.3-.227-.3.227.113-.365-.3-.226h.375Z",
    transform: "translate(5260.781 -773.153)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M420.775,1.162l.117.367h.375l-.3.227.117.366-.306-.226-.3.226.115-.366-.3-.227h.374Z",
    transform: "translate(5260.649 -772.653)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M420.775,2.923l.117.365h.375l-.3.226.117.368-.306-.227-.3.227.115-.368-.3-.226h.374Z",
    transform: "translate(5260.649 -772.795)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M420.775,4.683l.117.366h.375l-.3.226.117.367-.306-.227-.3.227.115-.367-.3-.226h.374Z",
    transform: "translate(5260.649 -772.937)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M420.775,6.442l.117.367h.375l-.3.226.117.366-.306-.225-.3.225.115-.366-.3-.226h.374Z",
    transform: "translate(5260.649 -773.078)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M420.775,8.2l.117.368h.375l-.3.225.117.366-.306-.226-.3.226.115-.366-.3-.225h.374Z",
    transform: "translate(5260.649 -773.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M422,2.089l.115.367h.377l-.306.227.117.366-.3-.225-.3.225.117-.366-.306-.227h.375Z",
    transform: "translate(5260.519 -772.727)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M422,3.85l.115.366h.377l-.306.227.117.365-.3-.224-.3.224.117-.365-.306-.227h.375Z",
    transform: "translate(5260.519 -772.869)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M422,5.61l.115.366h.377l-.306.227.117.366-.3-.226-.3.226.117-.366-.306-.227h.375Z",
    transform: "translate(5260.519 -773.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M422,7.37l.115.366h.377l-.306.226.117.365L422,8.1l-.3.227.117-.365-.306-.226h.375Z",
    transform: "translate(5260.519 -773.153)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M423.244,1.162l.117.367h.372l-.3.227.121.366-.306-.226-.3.226.115-.366-.3-.227h.374Z",
    transform: "translate(5260.387 -772.653)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M423.244,2.923l.117.365h.372l-.3.226.121.368-.306-.227-.3.227.115-.368-.3-.226h.374Z",
    transform: "translate(5260.387 -772.795)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M423.244,4.683l.117.366h.372l-.3.226.121.367-.306-.227-.3.227.115-.367-.3-.226h.374Z",
    transform: "translate(5260.387 -772.937)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M423.244,6.442l.117.367h.372l-.3.226.121.366-.306-.225-.3.225.115-.366-.3-.226h.374Z",
    transform: "translate(5260.387 -773.078)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M423.244,8.2l.117.368h.372l-.3.225.121.366-.306-.226-.3.226.115-.366-.3-.225h.374Z",
    transform: "translate(5260.387 -773.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M424.47,2.089l.115.367h.374l-.3.227.114.366-.3-.225-.3.225.113-.366-.3-.227h.374Z",
    transform: "translate(5260.257 -772.727)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M424.47,3.85l.115.366h.374l-.3.227.114.365-.3-.224-.3.224.113-.365-.3-.227h.374Z",
    transform: "translate(5260.257 -772.869)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M424.47,5.61l.115.366h.374l-.3.227.114.366-.3-.226-.3.226.113-.366-.3-.227h.374Z",
    transform: "translate(5260.257 -773.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M424.47,7.37l.115.366h.374l-.3.226.114.365-.3-.227-.3.227.113-.365-.3-.226h.374Z",
    transform: "translate(5260.257 -773.153)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M425.708,1.162l.117.367h.374l-.3.227.117.366-.306-.226-.3.226.114-.366-.3-.227h.374Z",
    transform: "translate(5260.125 -772.653)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M425.708,2.923l.117.365h.374l-.3.226.117.368-.306-.227-.3.227.114-.368-.3-.226h.374Z",
    transform: "translate(5260.125 -772.795)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M425.708,4.683l.117.366h.374l-.3.226.117.367-.306-.227-.3.227.114-.367-.3-.226h.374Z",
    transform: "translate(5260.125 -772.937)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M425.708,6.442l.117.367h.374l-.3.226.117.366-.306-.225-.3.225.114-.366-.3-.226h.374Z",
    transform: "translate(5260.125 -773.078)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M425.708,8.2l.117.368h.374l-.3.225.117.366-.306-.226-.3.226.114-.366-.3-.225h.374Z",
    transform: "translate(5260.125 -773.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M426.935,2.089l.115.367h.377l-.3.227.115.366-.3-.225-.3.225.117-.366-.3-.227h.375Z",
    transform: "translate(5259.995 -772.727)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M426.935,3.85l.115.366h.377l-.3.227.115.365-.3-.224-.3.224.117-.365-.3-.227h.375Z",
    transform: "translate(5259.995 -772.869)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M426.935,5.61l.115.366h.377l-.3.227.115.366-.3-.226-.3.226.117-.366-.3-.227h.375Z",
    transform: "translate(5259.995 -773.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M426.935,7.37l.115.366h.377l-.3.226.115.365-.3-.227-.3.227.117-.365-.3-.226h.375Z",
    transform: "translate(5259.995 -773.153)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M428.177,1.162l.117.367h.374l-.3.227.114.366-.3-.226-.3.226.114-.366-.3-.227h.374Z",
    transform: "translate(5259.863 -772.653)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M428.177,2.923l.117.365h.374l-.3.226.114.368-.3-.227-.3.227.114-.368-.3-.226h.374Z",
    transform: "translate(5259.863 -772.795)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M428.177,4.683l.117.366h.374l-.3.226.114.367-.3-.227-.3.227.114-.367-.3-.226h.374Z",
    transform: "translate(5259.863 -772.937)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M428.177,6.442l.117.367h.374l-.3.226.114.366-.3-.225-.3.225.114-.366-.3-.226h.374Z",
    transform: "translate(5259.863 -773.078)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M428.177,8.2l.117.368h.374l-.3.225.114.366-.3-.226-.3.226.114-.366-.3-.225h.374Z",
    transform: "translate(5259.863 -773.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M429.4,2.089l.113.367h.375l-.3.227.112.366-.3-.225-.306.225.117-.366-.3-.227h.372Z",
    transform: "translate(5259.733 -772.727)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M429.4,3.85l.113.366h.375l-.3.227.112.365-.3-.224-.306.224.117-.365-.3-.227h.372Z",
    transform: "translate(5259.733 -772.869)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M429.4,5.61l.113.366h.375l-.3.227.112.366-.3-.226-.306.226.117-.366-.3-.227h.372Z",
    transform: "translate(5259.733 -773.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M429.4,7.37l.113.366h.375l-.3.226.112.365-.3-.227-.306.227.117-.365-.3-.226h.372Z",
    transform: "translate(5259.733 -773.153)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M430.642,1.162l.119.367h.372l-.3.227.117.366-.306-.226-.3.226.114-.366-.3-.227h.374Z",
    transform: "translate(5259.601 -772.653)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M430.642,2.923l.119.365h.372l-.3.226.117.368-.306-.227-.3.227.114-.368-.3-.226h.374Z",
    transform: "translate(5259.601 -772.795)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M430.642,4.683l.119.366h.372l-.3.226.117.367-.306-.227-.3.227.114-.367-.3-.226h.374Z",
    transform: "translate(5259.601 -772.937)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M430.642,6.442l.119.367h.372l-.3.226.117.366-.306-.225-.3.225.114-.366-.3-.226h.374Z",
    transform: "translate(5259.601 -773.078)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M430.642,8.2l.119.368h.372l-.3.225.117.366-.306-.226-.3.226.114-.366-.3-.225h.374Z",
    transform: "translate(5259.601 -773.22)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsa);
export default __webpack_public_path__ + "static/media/USA.2e0646cd8ffe269b2d67e375178e8af6.svg";
export { ForwardRef as ReactComponent };